export const deleteMenuItemsOrSections = /* GraphQL */ `mutation DeleteMenuItemsOrSections($input: inputDeleteMenuItemsOrSections!) {
	deleteMenuItemsOrSections(input: $input){
		returnedCount
		items
	}
}`
